import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React from "react";
import {
    IconDepartment,
    PersonChipBlack
} from "../../../../../components/buttons/IconButtons";
import CustomAddChipSearch from "../../../../../components/CustomAddChipSearch";
import {
    departmentListToLabel,
    userListToLabelEmailPhoneValue
} from "../../../../../Apis/functions";
import {EXTRA_MEAL_TYPE_MODEL} from "../Model/Models";
import {SERVICE_ADVANCED_SEARCH} from "../../../../../reduxToolkit/Commons/CommonsApi";
import {TABLES} from "../../../../../Apis/Tables";
import {POSITION_MODEL} from "../../../../../Helpers/PositionModel";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : FullStack Developer
 * @Email : kpozos@ibl.mx
 *
 */
const ExtraMealTypeSection = (props) => {
    const { t } = useTranslation();
    const {
        extraMealType,
        selectedList,
        setSelectedList,
        emptyFields,
        cleanChipSearch,
        setCleanChipSearch,
        getBodyApi,
        apiSearchEmployee
    } = props;

    return (
        <>
            { extraMealType === EXTRA_MEAL_TYPE_MODEL.FOR_EMPLOYEES ?
                <>
                    <Box className='col-12 d-flex justify-content-center mb-4'>
                        <span className='font-color-text-950 ibl-font-w-700 fs-14px text-uppercase'>
                            {t('select_employees')}
                        </span>
                    </Box>
                    <div className={"col-12"}>
                        <CustomAddChipSearch
                            autocompleteId={'slt_emt_assign_employees'}
                            buttonId={'btn_emt_assign_employees'}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            bodyApi={getBodyApi()}
                            disabled={false}
                            label="assign_employees"
                            emptyFields={emptyFields}
                            required={true}
                            reset={false}
                            hideButton={false}
                            keyId={"userId"}
                            showSubSection={true}
                            showRenderOption={true}
                            maxLength={99}
                            sanitizeDataList={userListToLabelEmailPhoneValue}
                            Icon={PersonChipBlack}
                            cleanChipSearch={cleanChipSearch}
                            setCleanChipSearch={setCleanChipSearch}
                            helperText={t("each_selected_employee_equal_one_extra_meal")}
                            api={apiSearchEmployee}
                        />
                    </div>
                </>

                : extraMealType === EXTRA_MEAL_TYPE_MODEL.FOR_DEPARTMENTS ?
                    <>
                        <Box className='col-12 d-flex justify-content-center mb-4'>
                            <span className='font-color-text-950 ibl-font-w-700 fs-14px text-uppercase'>
                                {t('select_departments')}
                            </span>
                        </Box>
                        <div className={"col-12"}>
                            <CustomAddChipSearch
                                autocompleteId={'slt_emt_assign_departments'}
                                buttonId={'btn_emt_assign_departments'}
                                selectedList={selectedList}
                                setSelectedList={setSelectedList}
                                disabled={false}
                                label="assign_departments"
                                emptyFields={emptyFields}
                                required={true}
                                reset={false}
                                hideButton={false}
                                keyId={"id"}
                                showSubSection={true}
                                showRenderOption={true}
                                maxLength={99}
                                sanitizeDataList={departmentListToLabel}
                                Icon={IconDepartment}
                                chipIcon={IconDepartment}
                                cleanChipSearch={cleanChipSearch}
                                setCleanChipSearch={setCleanChipSearch}
                                helperText={t("every_employee_in_the_selected_department_will_receive_one_extra_meal")}
                                api={SERVICE_ADVANCED_SEARCH}
                                model={TABLES.DEPARTMENT_TOTAL_EMPLOYEES}
                                positionIconOptions={POSITION_MODEL.LEFT}
                            />
                        </div>
                    </>
                    : ''
            }
        </>
    );
};
export default ExtraMealTypeSection;
